module.exports = __webpack_public_path__ + "img/md-water.cd816137.svg";